import { defineStore } from "pinia";
import { ref } from "vue";
//@ts-ignore
import { getCurrentDeviceSize } from "@utils/DeviceDetection";
export var useMetadataStore = defineStore("metadataSoreId", function () {
  var _a;
  /*
  * Last element interacted: e.g. a modal or a component
  * */
  var location = ref(null);
  var device = ref(getCurrentDeviceSize());
  var pageName = ref((_a = window["page_type"]) !== null && _a !== void 0 ? _a : "");
  var setLocation = function setLocation(prevLocation) {
    location.value = prevLocation;
  };
  var setPageName = function setPageName(_pageName) {
    pageName.value = _pageName;
  };
  var setDevice = function setDevice(curDevice) {
    device.value = curDevice;
  };
  return {
    location: location,
    device: device,
    pageName: pageName,
    setLocation: setLocation,
    setPageName: setPageName,
    setDevice: setDevice
  };
});